import { routes } from '../routes'
import reducer from './reducers'
import * as calendarOperations from './operations'
import * as calendarSelector from './selectors'

export {
    calendarOperations,
    calendarSelector
};

export default {
    routes,
    reducer
}